import { createContext, useContext, useState } from 'react';

const AnalysisContext = createContext();

export function AnalysisProvider({ children }) {
  const [analysisData, setAnalysisData] = useState(null);
  const [breedGuide, setBreedGuide] = useState(null);
  const [userInput, setUserInput] = useState('');
  const [imageUrls, setImageUrls] = useState([]);
  const [petName, setPetName] = useState('');


  const updateAnalysis = (data, context = '') => {

    setAnalysisData(data);
    setUserInput(context);
  };

  const updateAnalysisFull = (data, context = '', breedGuide) => {
    setAnalysisData(data);
    setUserInput(context);
    setBreedGuide(breedGuide);
  };


  const clearContext = () => {
    setAnalysisData(null);
    setBreedGuide(null);
    setUserInput('');
    setImageUrls([]);
  };

  const updateImages = (urls = []) => {
    setImageUrls(urls);
  };

  const updateBreedGuide = (breedGuide = {}) => {
    setBreedGuide(breedGuide);
  };

  return (
    <AnalysisContext.Provider value={{ 
      analysisData, 
      breedGuide,
      userInput,
      imageUrls,
      petName,
      updateAnalysis,
      updateAnalysisFull,
      updateImages,
      updateBreedGuide,
      clearContext,
      setPetName, 
    }}>
      {children}
    </AnalysisContext.Provider>
  );
}

export const useAnalysis = () => {
  const context = useContext(AnalysisContext);
  if (!context) {
    throw new Error('useAnalysis must be used within an AnalysisProvider');
  }
  return context;
};